
import { MainLayout } from "@/components/layout/MainLayout";

export default function ResourcesCode() {
  return (
    <MainLayout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Κώδικας</h1>
        <p className="text-muted-foreground mb-6">
          Εδώ θα βρείτε παραδείγματα κώδικα και snippets για ανάπτυξη εφαρμογών.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="border rounded-lg p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center gap-2 mb-3">
                <CodeIcon className="h-5 w-5 text-primary" />
                <h3 className="font-medium">Παράδειγμα κώδικα {i}</h3>
              </div>
              <div className="bg-muted p-3 rounded-md mb-3 font-mono text-xs">
                <pre>{`function example${i}() {
  console.log("This is a code example");
  return "Hello Web Star!";
}`}</pre>
              </div>
              <p className="text-sm text-muted-foreground mb-3">
                Περιγραφή του κώδικα και της λειτουργικότητάς του.
              </p>
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium">5 Credits</span>
                <button className="text-primary text-sm hover:underline">Αντιγραφή</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}

function CodeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="16 18 22 12 16 6" />
      <polyline points="8 6 2 12 8 18" />
    </svg>
  );
}
